let colorIndex = 0;

export const getBgColor = colorList => {
  const bgColor = colorList[colorIndex];

  if (colorIndex === colorList.length - 1) {
    colorIndex = 0;
  } else {
    colorIndex++;
  }

  return bgColor;
};
